import React from "react";

import { Link } from "react-router-dom";
import { getEncodedValue } from "../../utils/Helpers";

import LazyImage from "../Shared/LazyImage";

const DeveloperCard = ({ model, isPreview = false }) => {
    const wrapLink = (component) => {
        const formattedName = getEncodedValue(model?.developedBy?.name);
        return (
            <Link
                to={
                    model?.developedBy?.name
                        ? `/partners/profile/${formattedName}`
                        : "#"
                }
            >
                {component}
            </Link>
        );
    };

    const component = (
        <div className="market-item-prod flex items-center">
            <div className="img-with-circle">
                <LazyImage
                    src={
                        model?.developedBy?.image ||
                        require("../../assets/images/org-avatar.png").default
                    }
                    alt={`${model?.developedBy?.name} logo`}
                />
            </div>
            <div className="justify-between">
                <h3 className="medium-title-bold capitalize">
                    {model?.developedBy?.name}
                </h3>
                <div className="text-xs text-dark-gray">
                    {model?.developedBy?.country}
                </div>
                {/* <div className="rate-items">
        <div className="rating-section flex items-center mb-2">
            <StarsRating starsRating={starsRating} />
        </div>
    </div> */}
            </div>
        </div>
    );

    return <>{isPreview ? component : wrapLink(component)}</>;
};

export default DeveloperCard;
